import { render, staticRenderFns } from "./BusinessTags.vue?vue&type=template&id=4e510d7d&"
import script from "./BusinessTags.vue?vue&type=script&lang=js&"
export * from "./BusinessTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports